/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./batch-confirm.vue?vue&type=template&id=6e37e75b&scoped=true&"
import script from "./batch-confirm.vue?vue&type=script&lang=ts&"
export * from "./batch-confirm.vue?vue&type=script&lang=ts&"
import style0 from "./batch-confirm.vue?vue&type=style&index=0&id=6e37e75b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e37e75b",
  null
  
)

export default component.exports